var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 50V0H100.25V100H0.25",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.175 50.175V54.25H35.175V91.25H44.4V54.25H57.4V50.25C57.4 48 57.4 46.175 57.3 46.125C57.3 46.05 49.375 46.025 39.75 46.025L22.25 46.1V50.2L22.175 50.175ZM80.6 46C83.15 46.6 85.1 47.75 86.85 49.575C87.775 50.575 89.15 52.325 89.25 52.775C89.25 52.925 84.925 55.85 82.3 57.475C82.2 57.55 81.8 57.125 81.4 56.475C80.1 54.625 78.775 53.825 76.7 53.675C73.7 53.475 71.7 55.05 71.7 57.675C71.7 58.475 71.85 58.925 72.15 59.575C72.825 60.95 74.075 61.775 77.95 63.475C85.1 66.55 88.2 68.575 90.075 71.475C92.2 74.725 92.675 79.825 91.25 83.65C89.65 87.825 85.75 90.65 80.175 91.575C78.425 91.875 74.425 91.825 72.55 91.5C68.55 90.75 64.725 88.75 62.375 86.175C61.45 85.175 59.675 82.5 59.775 82.325L60.725 81.725L64.475 79.55L67.3 77.9L67.95 78.775C68.775 80.075 70.625 81.825 71.7 82.425C74.95 84.1 79.3 83.875 81.45 81.925C82.375 81.075 82.775 80.175 82.775 78.925C82.775 77.775 82.6 77.25 82.025 76.375C81.225 75.275 79.625 74.375 75.125 72.375C69.95 70.175 67.75 68.775 65.7 66.625C64.525 65.325 63.45 63.3 62.95 61.625C62.575 60.175 62.45 56.625 62.8 55.2C63.875 50.2 67.65 46.7 73.05 45.7C74.8 45.35 78.925 45.5 80.65 45.95L80.6 46Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/ts.c08738205143e4590199e3c34713f0dc.svg";
export { ForwardRef as ReactComponent };